import { Helmet } from 'react-helmet';
import PhanquyendataDetail from 'src/components/phanquyendata-detail/PhanquyendataDetail';
import {
  Box,
  Container,
} from '@material-ui/core';

const Phanquyendata = () => (
  <>
    <Helmet>
      <title>Phần quyền data</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container style={{maxWidth: "100%"}}>
        <Box sx={{ pt: 3 }}>
          <PhanquyendataDetail />
        </Box>
      </Container>
    </Box>
  </>
);

export default Phanquyendata;
